// extracted by mini-css-extract-plugin
export default {"container":"Pk-z","blurb":"Qk-z","links":"Rk-z"};